module.exports = __webpack_public_path__ + "img/level1_idle_gun_mask.54c09c94.png";